import React from 'react';
import { Link } from 'react-router-dom';
import { MARKETS } from '../../data/services.mjs';
import { formatPrice as defaultFormat } from '../../utils/currency.mjs';
import './products.css';

const isInternal = (href) => href && href.startsWith('/');

const ProductCard = ({ product: p, formatPrice = defaultFormat }) => {
    const locale = p.currency === 'DOP' ? 'es-DO' : 'en-US';
    const price =
        p.pricing?.public && p.pricing.from != null ? formatPrice(p.pricing.from, p.currency, locale) : null;
    const links = [
        p.links?.site && { label: 'Sitio del producto', href: p.links.site, icon: 'fas fa-external-link-alt' },
        p.links?.googlePlay && { label: 'Google Play', href: p.links.googlePlay, icon: 'fab fa-google-play' },
        p.links?.appStore && { label: 'App Store', href: p.links.appStore, icon: 'fab fa-apple' },
    ].filter(Boolean);

    return (
        <article className="product-card">
            <div className="product-card__icon" aria-hidden="true">
                <i className={p.icon || 'fas fa-cube'}></i>
            </div>
            <h3 className="product-card__name">{p.name}</h3>
            {p.pitch && <p className="product-card__pitch">{p.pitch}</p>}
            <p className="product-card__tagline">{p.tagline}</p>
            {p.audience && (
                <p className="product-card__audience">
                    <strong>Para:</strong> {p.audience}
                </p>
            )}
            {p.problems?.length > 0 && (
                <>
                    <p className="product-card__label">¿Qué resuelve?</p>
                    <ul className="product-card__list product-card__list--problems">
                        {p.problems.map((h) => (
                            <li key={h}>{h}</li>
                        ))}
                    </ul>
                </>
            )}
            {p.highlights?.length > 0 && (
                <>
                    <p className="product-card__label">Cómo lo hace</p>
                    <ul className="product-card__list">
                        {p.highlights.map((h) => (
                            <li key={h}>{h}</li>
                        ))}
                    </ul>
                </>
            )}
            <p className="product-card__price">
                {price ? (
                    <>
                        Desde {price} <small>/ {p.pricing.period || 'mes'}</small>
                    </>
                ) : (
                    <small>Precio a consultar</small>
                )}
            </p>
            <div className="product-card__links">
                {links.map((l) =>
                    isInternal(l.href) ? (
                        <Link key={l.label} to={l.href}>
                            <i className={`${l.icon} mr-1`} aria-hidden="true"></i>
                            {l.label}
                        </Link>
                    ) : (
                        <a key={l.label} href={l.href} target="_blank" rel="noopener noreferrer">
                            <i className={`${l.icon} mr-1`} aria-hidden="true"></i>
                            {l.label}
                        </a>
                    )
                )}
                <a href="#contactenos">
                    <i className="fas fa-comment-dots mr-1" aria-hidden="true"></i>Solicitar demo
                </a>
            </div>
            <p className="product-card__markets mb-0">
                Disponible en: {(p.markets || ['RD']).map((m) => MARKETS[m]?.label || m).join(', ')}
            </p>
        </article>
    );
};

export default ProductCard;
